import React, { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import {
  convertTo12HourFormat,
  convertToIST12HourFormat,
  NumberFormatter,
} from "../../../../helpers/helpers";
import { getSocket } from "../../../../helpers/SingletonSocketService";
import { globalContext } from "../../../../context/ContextProvider";
import ConnectionStatus from "../../../buyerAuction/liveroom/updateLiveRoom/children/ConnectionStatus";

function LiveUpdatingArea({
  liveOfferData,
  veiwBidDetails,
  setVeiwBidDetails,
  setBidderDetails,
  singleAuctionData,
}) {
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1250px)" });
  const { sellerLiveRoomConnection } = useContext(globalContext);
  const [bidPrice, setBidPrice] = useState();

  useEffect(() => {
    const socket = getSocket();
    socket?.on("newBid", (data) => {
      if (data?.offerId === liveOfferData?._id) {
        const { bidHistory, ...restData } = data;
        setBidPrice(restData);
        setBidderDetails(bidHistory);
      }
    });
  }, [liveOfferData, setBidderDetails]);

  useEffect(() => {
    if (liveOfferData) {
      setBidPrice({
        highestBid: liveOfferData?.highestBid,
        bidDetails: {
          createdAt:
            liveOfferData?.bids?.length > 0
              ? liveOfferData.bids[liveOfferData.bids.length - 1]?.createdAt
              : "0000-00-00T00:00:00.000Z",
        },
      });
      setBidderDetails(liveOfferData?.bidHistory);
    }
  }, [liveOfferData, setBidderDetails]);

  if (sellerLiveRoomConnection) {
    return <ConnectionStatus />;
  }

  return (
    <div
      className={`gap-1 ${isLaptop && "valign-wrapper justify-center flex-wrap gap-3"
        }`}
      style={{
        display: !isLaptop && "grid",
        gridTemplateColumns: "1fr 1.5fr 2fr",
        padding: "2rem",
      }}
    >
      <div className="valign-wrapper column gap-2 justify-center">
        <h5
          className={`${isLaptop ? "font-16px" : "font-20px"
            } margin-0px valign-wrapper gap-1`}
        >
          Min Bid (INR):{" "}
          <span className="cercle-purple-text">
            Rs{" "}
            {liveOfferData?.minimumBid}
          </span>
        </h5>
        <button
          className={`button-style pointer font-16px white-text cercle-purple`}
          style={{ padding: "8px 20px" }}
          onClick={() => setVeiwBidDetails(!veiwBidDetails)}
        >
          <span className="valign-wrapper gap-10px">
            <span>View Bid Details</span>
            <span className="material-symbols-outlined">
              {veiwBidDetails ? "expand_less" : "expand_more"}
            </span>
          </span>
        </button>
      </div>

      <span className="valign-wrapper column justify-center gap-1">
        <h5
          className={`${isLaptop ? "font-25px" : "font-30px"
            } margin-0px cercle-purple-text valign-wrapper gap-10px`}
        >
          <span> Highest Bid </span>
          <span className="material-icons-outlined black-text font-30px">
            arrow_upward
          </span>
        </h5>
        <h6
          className={`${isLaptop ? "font-20px" : "font-25px"
            } white black-text border-1px margin-0px`}
          style={{ padding: isDastop ? "10px 40px" : "15px 60px" }}
        >
          {NumberFormatter(bidPrice?.highestBid) || 0}
        </h6>
      </span>

      <div
        className={`flex  column gap-10px ${isLaptop ? "font-16px" : "font-18px"
          }`}
      >
        <p className="NoOfline" style={{ WebkitLineClamp: 1 }}>
          {" "}
          <span className="cercle-purple-text">Description :</span>{" "}
          {liveOfferData?.description}
        </p>
        <p>
          {" "}
          <span className="cercle-purple-text">
            Last bid update time :
          </span>{" "}
          {convertToIST12HourFormat(bidPrice?.bidDetails?.createdAt)}
        </p>
        <p>
          {" "}
          <span className="cercle-purple-text">Auction end time :</span>{" "}
          {convertTo12HourFormat(
            singleAuctionData?.auctionSchedule?.endingTime
          )}
        </p>
      </div>
    </div>
  );
}

export default LiveUpdatingArea;
